var _path, _path2, _path3, _line, _path4, _path5, _rect, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReleuDePresiuneMinimaContactNormalDeschis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 84,
    viewBox: "0 0 76 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 83.6016V49.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: 42,
    x2: 21,
    y2: 42,
    stroke: "black",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 42H26.5",
    stroke: "black",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27 42H31.5",
    stroke: "black",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 32.5,
    width: 17,
    height: 17,
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.05682 46V37.2727H5.00568C5.69034 37.2727 6.25 37.3963 6.68466 37.6435C7.12216 37.8878 7.44602 38.2188 7.65625 38.6364C7.86648 39.054 7.97159 39.5199 7.97159 40.0341C7.97159 40.5483 7.86648 41.0156 7.65625 41.4361C7.44886 41.8565 7.12784 42.1918 6.69318 42.4418C6.25852 42.6889 5.7017 42.8125 5.02273 42.8125H2.90909V41.875H4.98864C5.45739 41.875 5.83381 41.794 6.1179 41.6321C6.40199 41.4702 6.60795 41.2514 6.7358 40.9759C6.86648 40.6974 6.93182 40.3835 6.93182 40.0341C6.93182 39.6847 6.86648 39.3722 6.7358 39.0966C6.60795 38.821 6.40057 38.6051 6.11364 38.4489C5.8267 38.2898 5.44602 38.2102 4.97159 38.2102H3.11364V46H2.05682ZM9.82741 42.1136V41.4318L15.3161 38.6364V39.7273L11.1058 41.7557L11.1399 41.6875V41.858L11.1058 41.7898L15.3161 43.8182V44.9091L9.82741 42.1136Z",
    fill: "#7C7C7C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22 28L38.6028 48.7332",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleuDePresiuneMinimaContactNormalDeschis);
export default __webpack_public_path__ + "static/media/releu_de_presiune_minima_contact_normal_deschis.76ee135e48ea0e272294822c89dbfa6d.svg";
export { ForwardRef as ReactComponent };